import { render, staticRenderFns } from "./SpecDetails.vue?vue&type=template&id=e2a38974"
import script from "./SpecDetails.vue?vue&type=script&lang=js"
export * from "./SpecDetails.vue?vue&type=script&lang=js"
import style0 from "./SpecDetails.vue?vue&type=style&index=0&id=e2a38974&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports